import classNames from 'classnames'
import React, { FC, useEffect, useState } from 'react'

import Pause from '../../../../assets/icons/pause.svg'
import Play from '../../../../assets/icons/play.svg'
import styles from './PlayPauseAnimation.module.scss'

type Props = {
  isPlaying: boolean
  className?: string
}

const PlayPauseAnimation: FC<Props> = ({ isPlaying, className }) => {
  const [numOfRun, setNumOfRun] = useState(0)

  useEffect(() => {
    if (numOfRun < 2 && isPlaying) setNumOfRun((v) => ++v)
  }, [isPlaying])

  return (
    <div
      className={classNames(
        styles.playPause,
        { [styles.playTrigger]: isPlaying && numOfRun >= 2 },
        { [styles.pauseTrigger]: !isPlaying && numOfRun >= 1 },
        className,
      )}
    >
      {isPlaying ? <Play /> : <Pause />}
    </div>
  )
}

export default PlayPauseAnimation
